

const AvailableTimeFrames = [
    { key: "1h", hours: 1 },
    { key: "4h", hours: 4 },
    { key: "12h", hours: 12 },
    { key: "1D", hours: 24 },
    { key: "1W", hours: 168 }
]

const TimeFramesData = (data) => {
    const ohlc = {}

    AvailableTimeFrames.forEach(frameDef => {
        const d = {} 
        d.ohlc = groupOHLC(data, frameDef.hours)
        ohlc[frameDef.key] = d
    });
    return ohlc
}

const TimeFrames = (key) => {
    return AvailableTimeFrames.find(function(element) {
        return element.key === key;
      });
}

const groupOHLC = (data, count) => {
    let current = { o: 0, h: 0, l: 0, c: 0 }
    let subindex = 0

    return data.reduce((result, currentValue, currentIndex, arr) => {
        if (subindex === 0) {
            current = { date: currentValue.date, Open: currentValue.Open, High: currentValue.High, Low: currentValue.Low, Close: currentValue.Close }
        }
        if (subindex > 0) {
            current.High = Math.max(current.High, currentValue.High)
            current.Low = Math.min(current.Low, currentValue.Low)
        }
        if (subindex === count - 1) {
            current.Close = currentValue.Close
            result.push(current)
        }

        subindex = (subindex === count - 1) ? 0 : subindex + 1
        return result
    }, [])
}

const groupSeries  = (data, count) => {
    let current = { v: 0 }
    let subindex = 0

    return data.reduce((result, currentValue, currentIndex, arr) => {
        if (subindex === 0) {
            current = { date: currentValue.date, v: Number(currentValue.v) }
        }
        if (subindex > 0) {
            current.v = (current.v + Number(currentValue.v)) * 0.5
        }
        if (subindex === count - 1) {
            result.push(current)
        }

        subindex = (subindex === count - 1) ? 0 : subindex + 1
        return result
    }, [])
}

export default TimeFrames;

export { groupSeries, groupOHLC, TimeFramesData, AvailableTimeFrames };


// WEBPACK FOOTER //
// ./src/ChartTimeFrames.js